import * as React from 'react'
import './App.css'
import UserSession from './Components/UserSession'
import Internationalization from './internationalization'
import Routes from './routes'
import { useDispatch } from 'react-redux'
import { setAccountCategoryVerificationStatus, setFrProUser } from './store/reducers/Users/users'
import { LoginApis } from './API/Login/LoginApi'
import { useLocation, useNavigate } from 'react-router-dom'
import { AccountCategoryAPIs } from './API/AccountCategory/AccountCategoryAPI'
import { ProfileApis } from './API/Login/ProfileApi'

function App() {
  const location = useLocation();
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userData = localStorage.getItem('Authorization'); // get the stored string
  const mainPageUrl = localStorage.getItem('mainPageUrl') || '';

  React.useEffect(() => {
    const firstSegment = location?.pathname?.split('/')[1] || '';

    if (userData) {
      LoginApis.whoamiUser(userData)
        .then(async (res) => {
          if (res?.data?.success === false) {
            console.warn('API success=false');
            return;
          }

          const userInfo = res?.data?.data;
          if (userInfo) {
            const categoryStatusObj = {
              userId: userInfo?.userId,
              fre8ProAccessToken: userInfo?.fre8ProAccessToken,
              operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
              operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
              clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
            };

            try {
              const response = await AccountCategoryAPIs.getUserCategoryStatusBoolean(categoryStatusObj);
              if (response?.success && response?.data) {
                userInfo.accountCategoryVerified = response?.data?.verified;
                userInfo.categoryInfo = response?.data; // ✅ Add the whole object for clarity
                dispatch(setAccountCategoryVerificationStatus(response?.data?.verified))
              }
            } catch (err) {
              console.error('userCategoryStatusBoolean failed:', err);
            }
            let mobileNumberObj = {
              fre8ProAccessToken: userInfo?.fre8ProAccessToken,
              viewerUserId: userInfo?.userId,
              targetUserId: userInfo?.userId,
              operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
              operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
              clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
            }
            await ProfileApis.getUserPersonalDetails(mobileNumberObj)
              .then((res) => {
                // Dispatch FrProUser Add extra Keys
                dispatch(
                  setFrProUser({
                    frProUser: {
                      ...userInfo,
                      emailId: res?.data?.personalInfoForm?.email,
                      mobileNumber: res?.data?.personalInfoForm?.mobileNumber,
                      locationForm: res?.data?.personalInfoForm?.locationForm,
                      fullName: res?.data?.personalInfoForm?.firstName + ' ' + res?.data?.personalInfoForm?.lastName,
                      profileId: res?.data?.profileId,
                    },
                  })
                )
              })
              .catch((err) => {
                console.debug('Mobile number not Available', err)
              })
          }
          const token = userInfo?.fre8ProAccessToken;
          // Store user info in Redux
          // dispatch(setFrProUser({ frProUser: userInfo }));

          // Save token to storage
          if (token) {
            sessionStorage.setItem('accessToken', JSON.stringify(token));
            localStorage.setItem('user', JSON.stringify({ fre8ProAccessToken: token }));
          }

          // Navigation logic
          if (res?.data?.fre8ProStatus === 'Standard') {
            console.log('---Fallback to dashboard---1');
            navigate('/profile', { username: 'test' });
          } else if (location?.pathname === '/') {
            console.log('---Fallback to dashboard---2');
            localStorage.removeItem('mainPageUrl')
            navigate('/dashboard', { username: 'test' });
          } else if (firstSegment === mainPageUrl) {
            console.log('---Fallback to dashboard---3');
            navigate(mainPageUrl && location?.pathname, { username: 'test' });
          } else {
            console.log('---Fallback to dashboard---4');
            localStorage.removeItem('mainPageUrl')
            navigate('/dashboard', { username: 'test' });
          }
        })
        .catch((err) => {
          console.error('whoamiUser failed:', err);
          localStorage.setItem('user', JSON.stringify({}));
          localStorage.removeItem('mainPageUrl');
          localStorage.removeItem('Authorization');
          navigate('/', { username: 'test' });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let userList = JSON.parse(localStorage.getItem('usersList'))
  userList =
    userList === '' || userList === null || userList === undefined
      ? []
      : userList
  localStorage.setItem('usersList', JSON.stringify(userList))

  let user = JSON.parse(localStorage.getItem('user'))
  user = user === '' || user === null || user === undefined ? {} : user
  localStorage.setItem('user', JSON.stringify(user))

  let loogedInUserbuddyList = JSON.parse(
    localStorage.getItem('loogedInUserbuddyList')
  )
  loogedInUserbuddyList =
    loogedInUserbuddyList === '' ||
      loogedInUserbuddyList === null ||
      loogedInUserbuddyList === undefined
      ? []
      : loogedInUserbuddyList
  localStorage.setItem(
    'loogedInUserbuddyList',
    JSON.stringify(loogedInUserbuddyList)
  )

  let requestSentToUserbuddyList = JSON.parse(
    localStorage.getItem('requestSentToUserbuddyList')
  )
  requestSentToUserbuddyList =
    requestSentToUserbuddyList === '' ||
      requestSentToUserbuddyList === null ||
      requestSentToUserbuddyList === undefined
      ? []
      : requestSentToUserbuddyList
  localStorage.setItem(
    'requestSentToUserbuddyList',
    JSON.stringify(requestSentToUserbuddyList)
  )

  let notificationList = JSON.parse(localStorage.getItem('notificationList'))
  notificationList =
    notificationList === '' ||
      notificationList === undefined ||
      notificationList === null
      ? []
      : notificationList
  localStorage.setItem('notificationList', JSON.stringify(notificationList))

  let usercategory = JSON.parse(localStorage.getItem('usercategory'))
  usercategory =
    usercategory === '' || usercategory === null || usercategory === undefined
      ? ''
      : usercategory
  localStorage.setItem('usercategory', JSON.stringify(usercategory))

  let userSession = JSON.parse(sessionStorage.getItem('userSession'))
  userSession =
    userSession === '' || userSession === null || userSession === undefined
      ? ''
      : userSession
  sessionStorage.setItem('userSession', JSON.stringify(userSession))

  // let accessToken = JSON.parse(sessionStorage.getItem('accessToken'));
  // accessToken = accessToken === '' || accessToken === null || accessToken === undefined ? {} : accessToken
  // sessionStorage.setItem('accessToken', JSON.stringify(accessToken));

  return (
    <UserSession>
      <Internationalization>
        <Routes />
      </Internationalization>
    </UserSession>
  )
}

export default App
